var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "bubble-settings" }, [
    _c("div", { staticClass: "page-header" }, [
      _c("div", { staticClass: "title" }, [
        _vm._v(_vm._s(_vm.$t("settings.bubbleSettings"))),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "subtitle" }, [
        _vm._v(_vm._s(_vm.$t("settings.bubbleSettingsSubtitles"))),
      ]),
    ]),
    _vm._v(" "),
    _c("section", [
      _c(
        "div",
        { staticClass: "fields" },
        [
          _c("FeatureItem", {
            attrs: {
              title: _vm.$t("message.animations"),
              icon: "AnimationIcon",
              description: _vm.$t("message.preferredAnimation"),
              type: "select",
              options: _vm.allAnimations.map(function (x) {
                return { id: x, label: x }
              }),
              "default-select-option-placeholder": _vm.$t(
                "message.selectAnAnimation"
              ),
            },
            model: {
              value: _vm.preferredAnimation,
              callback: function ($$v) {
                _vm.preferredAnimation = $$v
              },
              expression: "preferredAnimation",
            },
          }),
          _vm._v(" "),
          _c("FeatureItem", {
            attrs: {
              title: _vm.$t("message.chatPosition"),
              icon: "ChatLocation",
              description: _vm.$t("message.chatPosition"),
              type: "select",
              options: _vm.chatPositionOptions,
              "default-select-option-placeholder": _vm.$t(
                "message.chatPositionSelect"
              ),
            },
            model: {
              value: _vm.position,
              callback: function ($$v) {
                _vm.position = $$v
              },
              expression: "position",
            },
          }),
          _vm._v(" "),
          _c("FeatureItem", {
            attrs: {
              description: _vm.$t("message.vtippyAutoHideBubble"),
              title: _vm.$t("message.autoHideBubble"),
              icon: "HideIcon",
            },
            model: {
              value: _vm.autoHideBubble,
              callback: function ($$v) {
                _vm.autoHideBubble = $$v
              },
              expression: "autoHideBubble",
            },
          }),
          _vm._v(" "),
          _c("FeatureItem", {
            attrs: {
              description: _vm.$t("message.vtippyHideBubble"),
              title: _vm.$t("message.hideBubble"),
              icon: "NewHiddenIcon",
            },
            model: {
              value: _vm.hideBubble,
              callback: function ($$v) {
                _vm.hideBubble = $$v
              },
              expression: "hideBubble",
            },
          }),
          _vm._v(" "),
          _c("FeatureItem", {
            attrs: {
              description: _vm.$t("message.vtippyHideBubbleOnMobile"),
              title: _vm.$t("message.hideBubbleOnMobile"),
              icon: "HideMobile",
            },
            model: {
              value: _vm.hideBubbleOnMobile,
              callback: function ($$v) {
                _vm.hideBubbleOnMobile = $$v
              },
              expression: "hideBubbleOnMobile",
            },
          }),
          _vm._v(" "),
          _c("FeatureItem", {
            attrs: {
              description: _vm.$t("message.vtipyBrandVisibility"),
              title: _vm.$t("message.brandVisibility"),
              icon: "TickedIcon",
            },
            model: {
              value: _vm.brandVisible,
              callback: function ($$v) {
                _vm.brandVisible = $$v
              },
              expression: "brandVisible",
            },
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "custom-field-slider" },
            [
              _vm.isModal2Show
                ? _c(
                    "Modal2",
                    {
                      attrs: {
                        id: "bubble-icon-modal",
                        title: _vm.$t("message.bubbleIcon"),
                        "show-footer": false,
                      },
                      on: { cancel: _vm.hideModal2 },
                    },
                    [
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            {
                              staticClass: "bubbles-modal",
                              attrs: { md: "12" },
                            },
                            [
                              _c("label", [
                                _vm._v(_vm._s(_vm.$t("message.preDefined"))),
                              ]),
                              _vm._v(" "),
                              _c(
                                "b-row",
                                [
                                  _c(
                                    "b-col",
                                    { staticClass: "mt-3", attrs: { md: "3" } },
                                    [
                                      _c("img", {
                                        class: {
                                          selected: _vm.preDefined === "1",
                                        },
                                        staticStyle: {
                                          width: "100px",
                                          height: "100px",
                                          "object-fit": "contain",
                                        },
                                        attrs: {
                                          src: "/static/img/bubbles/btn1.svg",
                                        },
                                        on: {
                                          click: function ($event) {
                                            _vm.preDefined = "1"
                                          },
                                        },
                                      }),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-col",
                                    { staticClass: "mt-3", attrs: { md: "3" } },
                                    [
                                      _c("img", {
                                        class: {
                                          selected: _vm.preDefined === "2",
                                        },
                                        staticStyle: {
                                          width: "100px",
                                          height: "100px",
                                          "object-fit": "contain",
                                        },
                                        attrs: {
                                          src: "/static/img/bubbles/btn2.svg",
                                        },
                                        on: {
                                          click: function ($event) {
                                            _vm.preDefined = "2"
                                          },
                                        },
                                      }),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-col",
                                    { staticClass: "mt-3", attrs: { md: "3" } },
                                    [
                                      _c("img", {
                                        class: {
                                          selected: _vm.preDefined === "3",
                                        },
                                        staticStyle: {
                                          width: "100px",
                                          height: "100px",
                                          "object-fit": "contain",
                                        },
                                        attrs: {
                                          src: "/static/img/bubbles/btn3.svg",
                                        },
                                        on: {
                                          click: function ($event) {
                                            _vm.preDefined = "3"
                                          },
                                        },
                                      }),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-col",
                                    { staticClass: "mt-3", attrs: { md: "3" } },
                                    [
                                      _c("img", {
                                        class: {
                                          selected: _vm.preDefined === "4",
                                        },
                                        staticStyle: {
                                          width: "100px",
                                          height: "100px",
                                          "object-fit": "contain",
                                        },
                                        attrs: {
                                          src: "/static/img/bubbles/btn4.svg",
                                        },
                                        on: {
                                          click: function ($event) {
                                            _vm.preDefined = "4"
                                          },
                                        },
                                      }),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-col",
                                    { staticClass: "mt-3", attrs: { md: "3" } },
                                    [
                                      _c("img", {
                                        class: {
                                          selected: _vm.preDefined === "5",
                                        },
                                        staticStyle: {
                                          width: "100px",
                                          height: "100px",
                                          "object-fit": "contain",
                                        },
                                        attrs: {
                                          src: "/static/img/bubbles/btn5.svg",
                                        },
                                        on: {
                                          click: function ($event) {
                                            _vm.preDefined = "5"
                                          },
                                        },
                                      }),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-col",
                                    { staticClass: "mt-3", attrs: { md: "3" } },
                                    [
                                      _c("img", {
                                        class: {
                                          selected: _vm.preDefined === "6",
                                        },
                                        staticStyle: {
                                          width: "100px",
                                          height: "100px",
                                          "object-fit": "contain",
                                        },
                                        attrs: {
                                          src: "/static/img/bubbles/btn6.svg",
                                        },
                                        on: {
                                          click: function ($event) {
                                            _vm.preDefined = "6"
                                          },
                                        },
                                      }),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-col",
                                    { staticClass: "mt-3", attrs: { md: "3" } },
                                    [
                                      _c("img", {
                                        class: {
                                          selected: _vm.preDefined === "7",
                                        },
                                        staticStyle: {
                                          width: "100px",
                                          height: "100px",
                                          "object-fit": "contain",
                                        },
                                        attrs: {
                                          src: "/static/img/bubbles/btn7.svg",
                                        },
                                        on: {
                                          click: function ($event) {
                                            _vm.preDefined = "7"
                                          },
                                        },
                                      }),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "mt-3",
                                      attrs: { md: "12" },
                                    },
                                    [
                                      _c("label", [
                                        _vm._v(
                                          _vm._s(_vm.$t("message.customIcon"))
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "d-flex align-items-center",
                                        },
                                        [
                                          _c(
                                            "md-button",
                                            {
                                              staticClass: "mr-3",
                                              on: { click: _vm.selectFile },
                                            },
                                            [_c("md-icon", [_vm._v("upload")])],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _vm.newIcon ||
                                          (!!_vm.settings.bubble &&
                                            !!_vm.settings.bubble.customIcon)
                                            ? _c("img", {
                                                class: {
                                                  selected:
                                                    _vm.preDefined === "0",
                                                },
                                                staticStyle: {
                                                  width: "100px",
                                                  height: "100px",
                                                  "object-fit": "contain",
                                                },
                                                attrs: {
                                                  src: _vm.bubbleIcon,
                                                  alt: "bubble",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    _vm.preDefined = "0"
                                                  },
                                                },
                                              })
                                            : _vm._e(),
                                        ],
                                        1
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-col",
                                    { attrs: { md: "12 mt-2" } },
                                    [
                                      _c(
                                        "b-button",
                                        {
                                          attrs: { variant: "primary" },
                                          on: { click: _vm.selectBubble },
                                        },
                                        [
                                          [
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(_vm.$t("message.ok"))
                                              ),
                                            ]),
                                          ],
                                        ],
                                        2
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-button",
                                        { on: { click: _vm.hideModal2 } },
                                        [
                                          [
                                            _vm._v(
                                              _vm._s(_vm.$t("message.cancel"))
                                            ),
                                          ],
                                        ],
                                        2
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "a-card",
            {
              staticStyle: { width: "500px" },
              attrs: { hoverable: "" },
              scopedSlots: _vm._u([
                {
                  key: "cover",
                  fn: function () {
                    return [
                      _c("div", { staticClass: "bubble-box" }, [
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "tippy",
                                rawName: "v-tippy",
                                value: {
                                  followCursor: true,
                                  placement: "bottom-end",
                                },
                                expression:
                                  "{ followCursor: true, placement: 'bottom-end' }",
                              },
                            ],
                            staticClass: "align-items-center text-align-center",
                            attrs: { content: _vm.$t("message.bubbleIcon") },
                          },
                          [
                            _vm.newIcon ||
                            (!!_vm.settings.bubble && _vm.preDefined === 0)
                              ? _c("img", {
                                  staticClass: "img-thumbnail img-select",
                                  staticStyle: {
                                    width: "100px",
                                    height: "100px",
                                    "object-fit": "contain",
                                  },
                                  attrs: { src: _vm.bubbleIcon, alt: "bubble" },
                                  on: { click: _vm.showModal2 },
                                })
                              : _c(
                                  "div",
                                  { on: { click: _vm.showModal2 } },
                                  _vm._l(_vm.$_.range(1, 8), function (i) {
                                    return _vm.preDefined == i
                                      ? _c("Bubble" + i, {
                                          key: i,
                                          tag: "component",
                                          staticClass:
                                            "bubble img-thumbnail img-select",
                                          attrs: { color: _vm.bubbleColor },
                                        })
                                      : _vm._e()
                                  }),
                                  1
                                ),
                            _vm._v(" "),
                            _c(
                              "label",
                              { staticStyle: { "font-weight": "bold" } },
                              [_vm._v(_vm._s(_vm.$t("message.bubbleIcon")))]
                            ),
                          ]
                        ),
                      ]),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "actions",
                  fn: function () {
                    return [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "tippy",
                              rawName: "v-tippy",
                              value: {
                                followCursor: true,
                                placement: "bottom-end",
                                theme: _vm.isDarkMode
                                  ? "light-border"
                                  : "google",
                              },
                              expression:
                                "{\n                            followCursor: true,\n                            placement: 'bottom-end',\n                            theme: isDarkMode ? 'light-border' : 'google',\n                        }",
                            },
                          ],
                          staticClass: "custom-field-button",
                          staticStyle: { padding: "5px" },
                          attrs: {
                            content: _vm.offlineMode
                              ? _vm.$t("message.viewOnTheSiteTippy")
                              : _vm.$t("message.viewOnTheSiteTippy"),
                          },
                        },
                        [
                          _c(
                            "a",
                            {
                              style: {
                                color: _vm.isDarkMode ? "#fff" : "#000",
                              },
                              attrs: {
                                href: _vm.visitorScreenUrl,
                                target: "_blank",
                              },
                            },
                            [
                              _c(
                                "md-icon",
                                { staticStyle: { color: "#369afe" } },
                                [_vm._v("preview")]
                              ),
                              _vm._v(
                                "\n                            " +
                                  _vm._s(_vm.$t("message.viewOnTheSite")) +
                                  "\n                        "
                              ),
                            ],
                            1
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        [
                          _c(
                            "a-button",
                            {
                              directives: [
                                {
                                  name: "tippy",
                                  rawName: "v-tippy",
                                  value: {
                                    followCursor: true,
                                    placement: "bottom-end",
                                  },
                                  expression:
                                    "{\n                                followCursor: true,\n                                placement: 'bottom-end',\n                            }",
                                },
                              ],
                              staticClass: "btn btn primary override-margins",
                              attrs: {
                                content: _vm.$t(
                                  "message.inputPixelsOfChatBubble"
                                ),
                              },
                              on: { click: _vm.showModal },
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("message.overrideMargins")) +
                                  "\n                        "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "a-modal",
                            {
                              attrs: {
                                id: "margin-inputs",
                                title: "",
                                footer: false,
                              },
                              on: { cancel: _vm.afterModalClosed },
                              model: {
                                value: _vm.visible,
                                callback: function ($$v) {
                                  _vm.visible = $$v
                                },
                                expression: "visible",
                              },
                            },
                            [
                              _c("div", { staticClass: "container" }, [
                                _c("h6", { staticClass: "pb-5" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "message.modalTitleIsMarginAsPixelInfo"
                                      )
                                    )
                                  ),
                                ]),
                                _vm._v(" "),
                                _vm.isDisplayedMarginEdit ||
                                !!_vm.marginX ||
                                !!_vm.marginY
                                  ? _c("div", [
                                      _c("div", { staticClass: "row" }, [
                                        _c(
                                          "div",
                                          { staticClass: "col-sm-6" },
                                          [
                                            _c("label", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "message.inputPxOfXaxis"
                                                  )
                                                ) + "( PX )"
                                              ),
                                            ]),
                                            _vm._v(" "),
                                            _c(
                                              "md-field",
                                              {
                                                class: {
                                                  "md-invalid":
                                                    _vm.errors.first(
                                                      _vm.$t(
                                                        "message.inputPxOfXaxis"
                                                      )
                                                    ) != null,
                                                },
                                              },
                                              [
                                                _c("md-input", {
                                                  attrs: {
                                                    name: _vm.$t(
                                                      "message.inputPxOfXaxis"
                                                    ),
                                                    autocomplete: "off",
                                                    placeholder: "px",
                                                    type: "number",
                                                  },
                                                  model: {
                                                    value: _vm.marginX,
                                                    callback: function ($$v) {
                                                      _vm.marginX = $$v
                                                    },
                                                    expression: "marginX",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "col-sm-6" },
                                          [
                                            _c("label", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "message.inputPxOfYaxis"
                                                  )
                                                ) + "( PX )"
                                              ),
                                            ]),
                                            _vm._v(" "),
                                            _c(
                                              "md-field",
                                              {
                                                class: {
                                                  "md-invalid":
                                                    _vm.errors.first(
                                                      _vm.$t(
                                                        "message.inputPxOfYaxis"
                                                      )
                                                    ) != null,
                                                },
                                              },
                                              [
                                                _c("md-input", {
                                                  attrs: {
                                                    name: _vm.$t(
                                                      "message.inputPxOfYaxis"
                                                    ),
                                                    autocomplete: "off",
                                                    placeholder: "px",
                                                    type: "number",
                                                  },
                                                  model: {
                                                    value: _vm.marginY,
                                                    callback: function ($$v) {
                                                      _vm.marginY = $$v
                                                    },
                                                    expression: "marginY",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ]),
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      margin: "30px 0 30px 0",
                                      "text-align": "center",
                                    },
                                  },
                                  [
                                    _c(
                                      "a-button",
                                      {
                                        staticStyle: {
                                          border: "none",
                                          background: "none",
                                          "font-weight": "500",
                                          "font-size": "medium",
                                        },
                                        on: {
                                          click: function () {
                                            return _vm.returnDefaultMarginSetting()
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "message.returnDefaultMargins"
                                            )
                                          ) +
                                            "\n                                    "
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("div", [
                                  _c(
                                    "div",
                                    {
                                      directives: [
                                        {
                                          name: "tippy",
                                          rawName: "v-tippy",
                                          value: {
                                            followCursor: true,
                                            placement: "bottom-end",
                                          },
                                          expression:
                                            "{\n                                            followCursor: true,\n                                            placement: 'bottom-end',\n                                        }",
                                        },
                                      ],
                                      staticClass: "custom-field-switch",
                                      attrs: {
                                        content: _vm.$t(
                                          "message.vtippyOverrideMobileMargin"
                                        ),
                                      },
                                    },
                                    [
                                      _c("label", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "message.overrideMobileMargin"
                                            )
                                          )
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("md-switch", {
                                        staticClass: "md-primary ml-3",
                                        attrs: {
                                          name: "subject",
                                          required: "",
                                        },
                                        model: {
                                          value: _vm.overrideMobileMargin,
                                          callback: function ($$v) {
                                            _vm.overrideMobileMargin = $$v
                                          },
                                          expression: "overrideMobileMargin",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _vm.overrideMobileMargin
                                    ? _c("div", [
                                        _c("div", { staticClass: "row" }, [
                                          _c(
                                            "div",
                                            { staticClass: "col-sm-6" },
                                            [
                                              _c("label", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "message.inputPxOfMobileXaxis"
                                                    )
                                                  ) + "( PX )"
                                                ),
                                              ]),
                                              _vm._v(" "),
                                              _c(
                                                "md-field",
                                                {
                                                  class: {
                                                    "md-invalid":
                                                      _vm.errors.first(
                                                        _vm.$t(
                                                          "message.inputPxOfMobileXaxis"
                                                        )
                                                      ) != null,
                                                  },
                                                },
                                                [
                                                  _c("md-input", {
                                                    attrs: {
                                                      name: _vm.$t(
                                                        "message.inputPxOfMobileXaxis"
                                                      ),
                                                      autocomplete: "off",
                                                      placeholder: "px",
                                                      type: "number",
                                                    },
                                                    model: {
                                                      value: _vm.mobileMarginX,
                                                      callback: function ($$v) {
                                                        _vm.mobileMarginX = $$v
                                                      },
                                                      expression:
                                                        "mobileMarginX",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "col-sm-6" },
                                            [
                                              _c("label", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "message.inputPxOfMobileYaxis"
                                                    )
                                                  ) + "( PX )"
                                                ),
                                              ]),
                                              _vm._v(" "),
                                              _c(
                                                "md-field",
                                                {
                                                  class: {
                                                    "md-invalid":
                                                      _vm.errors.first(
                                                        _vm.$t(
                                                          "message.inputPxOfMobileYaxis"
                                                        )
                                                      ) != null,
                                                  },
                                                },
                                                [
                                                  _c("md-input", {
                                                    attrs: {
                                                      name: _vm.$t(
                                                        "message.inputPxOfMobileYaxis"
                                                      ),
                                                      autocomplete: "off",
                                                      placeholder: "px",
                                                      type: "number",
                                                    },
                                                    model: {
                                                      value: _vm.mobileMarginY,
                                                      callback: function ($$v) {
                                                        _vm.mobileMarginY = $$v
                                                      },
                                                      expression:
                                                        "mobileMarginY",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ]),
                                      ])
                                    : _vm._e(),
                                ]),
                                _vm._v(" "),
                                _c("span", { staticClass: "md-error" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.errors.first(
                                        _vm.$t(
                                          "message.inputPixelsOfChatBubble"
                                        )
                                      )
                                    )
                                  ),
                                ]),
                              ]),
                            ]
                          ),
                        ],
                        1
                      ),
                    ]
                  },
                  proxy: true,
                },
              ]),
            },
            [
              _vm._v(" "),
              _vm._v(" "),
              _c("a-card-meta", {
                scopedSlots: _vm._u([
                  {
                    key: "avatar",
                    fn: function () {
                      return [
                        _c("div", { staticClass: "feature avatar" }, [
                          _c("div", { staticClass: "left" }, [
                            _c("div", { staticClass: "texts" }, [
                              _c("div", { staticClass: "feature-title" }, [
                                _vm.preDefined !== 0
                                  ? _c(
                                      "div",
                                      {
                                        directives: [
                                          {
                                            name: "tippy",
                                            rawName: "v-tippy",
                                            value: {
                                              followCursor: true,
                                              placement: "bottom-end",
                                            },
                                            expression:
                                              "{ followCursor: true, placement: 'bottom-end' }",
                                          },
                                        ],
                                        attrs: {
                                          content: _vm.$t(
                                            "message.bubbleColor"
                                          ),
                                        },
                                      },
                                      [
                                        _c(
                                          "label",
                                          { attrs: { for: "bubbleColor" } },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("message.bubbleColor")
                                              )
                                            ),
                                          ]
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ]),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "right" },
                            [
                              _c("a-input", {
                                staticClass: "theme-color-input",
                                staticStyle: { width: "100px" },
                                attrs: { id: "bubbleColor", type: "color" },
                                model: {
                                  value: _vm.bubbleColor,
                                  callback: function ($$v) {
                                    _vm.bubbleColor = $$v
                                  },
                                  expression: "bubbleColor",
                                },
                              }),
                            ],
                            1
                          ),
                        ]),
                        _vm._v(" "),
                        !!_vm.marginX || !!_vm.marginY
                          ? _c(
                              "div",
                              {
                                staticClass: "feature",
                                staticStyle: {
                                  width: "450px",
                                  "margin-bottom": "20px",
                                  display: "flex",
                                  "justify-content": "center",
                                },
                              },
                              [
                                _c("div", { staticClass: "texts" }, [
                                  _c("div", { staticClass: "feature-title" }, [
                                    _c(
                                      "div",
                                      {
                                        directives: [
                                          {
                                            name: "tippy",
                                            rawName: "v-tippy",
                                            value: {
                                              followCursor: true,
                                              placement: "bottom-end",
                                            },
                                            expression:
                                              "{\n                                            followCursor: true,\n                                            placement: 'bottom-end',\n                                        }",
                                          },
                                        ],
                                        staticClass:
                                          "custom-field-switch d-flex flex-column",
                                        on: {
                                          click: function ($event) {
                                            return _vm.showModalDirectly()
                                          },
                                        },
                                      },
                                      [
                                        _c("label", [
                                          !!_vm.marginX
                                            ? _c(
                                                "p",
                                                {
                                                  staticStyle: {
                                                    "margin-bottom": "5px",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                                " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "message.inputPxOfXaxis"
                                                        )
                                                      ) +
                                                      " : " +
                                                      _vm._s(_vm.marginX) +
                                                      _vm._s(_vm.marginText) +
                                                      "\n                                            "
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          !!_vm.marginY
                                            ? _c(
                                                "p",
                                                {
                                                  staticStyle: {
                                                    "margin-bottom": "0px",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                                " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "message.inputPxOfYaxis"
                                                        )
                                                      ) +
                                                      " : " +
                                                      _vm._s(_vm.marginY) +
                                                      _vm._s(_vm.marginText) +
                                                      "\n                                            "
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                        ]),
                                        _vm._v(" "),
                                        _vm.overrideMobileMargin
                                          ? _c("label", [
                                              !!_vm.mobileMarginX
                                                ? _c(
                                                    "p",
                                                    {
                                                      staticStyle: {
                                                        "margin-bottom": "5px",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                                                " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "message.inputPxOfMobileXaxis"
                                                            )
                                                          ) +
                                                          " : " +
                                                          _vm._s(
                                                            _vm.mobileMarginX
                                                          ) +
                                                          _vm._s(
                                                            _vm.marginText
                                                          ) +
                                                          "\n                                            "
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              !!_vm.mobileMarginY
                                                ? _c(
                                                    "p",
                                                    {
                                                      staticStyle: {
                                                        "margin-bottom": "0px",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                                                " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "message.inputPxOfMobileYaxis"
                                                            )
                                                          ) +
                                                          " : " +
                                                          _vm._s(
                                                            _vm.mobileMarginY
                                                          ) +
                                                          _vm._s(
                                                            _vm.marginText
                                                          ) +
                                                          "\n                                            "
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ])
                                          : _vm._e(),
                                      ]
                                    ),
                                  ]),
                                ]),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c("div", { staticClass: "feature" }, [
                          _c("div", { staticClass: "left" }, [
                            _c("div", { staticClass: "texts" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "feature-title",
                                  class: {
                                    "md-invalid":
                                      _vm.errors.first(
                                        _vm.$t("message.inputHeightOfBubble")
                                      ) != null,
                                  },
                                  staticStyle: { "font-size": "14px" },
                                },
                                [
                                  _vm._v(
                                    "\n                                        " +
                                      _vm._s(
                                        _vm.$t("message.inputHeightOfBubble")
                                      ) +
                                      "\n                                    "
                                  ),
                                ]
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "right" },
                            [
                              _c(
                                "a-input",
                                {
                                  attrs: {
                                    name: _vm.$t("message.inputHeightOfBubble"),
                                    autocomplete: "off",
                                    placeholder: "60",
                                    type: "number",
                                  },
                                  model: {
                                    value: _vm.heightOfBubble,
                                    callback: function ($$v) {
                                      _vm.heightOfBubble = $$v
                                    },
                                    expression: "heightOfBubble",
                                  },
                                },
                                [_vm._v("px\n                                ")]
                              ),
                            ],
                            1
                          ),
                        ]),
                        _vm._v(" "),
                        _vm.preDefined == 7
                          ? _c("div", [
                              _c(
                                "div",
                                {
                                  staticClass: "feature",
                                  staticStyle: { "margin-top": "15px" },
                                },
                                [
                                  _c("div", { staticClass: "left" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "text",
                                        on: { click: _vm.chatBubbleTextModal },
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "feature-title" },
                                          [
                                            _vm._v(
                                              "\n                                            " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "settings.chatBubbleTextSetting"
                                                  )
                                                ) +
                                                "\n                                        "
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "feature-description",
                                          },
                                          [
                                            _vm._v(
                                              "\n                                            " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "settings.textOnChatBubble"
                                                  )
                                                ) +
                                                "\n                                        "
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "right" }),
                                  _vm._v(" "),
                                  _c(
                                    "a-modal",
                                    {
                                      attrs: {
                                        id: "margin-inputs",
                                        title: "",
                                        footer: false,
                                      },
                                      on: { cancel: _vm.afterModalClosed },
                                      model: {
                                        value: _vm.chatBubbleTextModalVisible,
                                        callback: function ($$v) {
                                          _vm.chatBubbleTextModalVisible = $$v
                                        },
                                        expression:
                                          "chatBubbleTextModalVisible",
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "container",
                                          on: {
                                            click: function ($event) {
                                              $event.stopPropagation()
                                            },
                                          },
                                        },
                                        [
                                          _c("h5", [
                                            _vm._v(
                                              "\n                                            " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "settings.textToAppearOnChatBubble"
                                                  )
                                                ) +
                                                "\n                                        "
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _c("MultiContent", {
                                            ref: "MultiContent",
                                            model: {
                                              value: _vm.osrInitialObject,
                                              callback: function ($$v) {
                                                _vm.osrInitialObject = $$v
                                              },
                                              expression: "osrInitialObject",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ])
                          : _vm._e(),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }